import React, { Children } from 'react';

import { Box } from '@mui/material';
import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { operationCellStyles } from '../../EntityAuditHistory.styles';
import { EntityAuditHistoryTestIds } from '../../EntityAuditHistory.testIds';
import {
  getOperationLabel,
  getOperationVariant,
  toOperation,
} from '../../EntityAuditHistory.utils';

/** The operation pill, with a decorated row's scope chips (e.g. Global / Your override) under it. */
const AuditOperationCell = ({ summary, chips = null }) => {
  const operation = toOperation(summary.operation);
  const label = (
    <LabelCDS
      size={LabelSize.S}
      title={getOperationLabel(operation)}
      variant={getOperationVariant(operation)}
    />
  );

  if (_.isEmpty(chips)) {
    return label;
  }

  return (
    <Box data-testid={EntityAuditHistoryTestIds.ROW_CHIPS} sx={operationCellStyles}>
      {label}
      {Children.toArray(chips)}
    </Box>
  );
};

AuditOperationCell.propTypes = {
  summary: PropTypes.object.isRequired,
  chips: PropTypes.arrayOf(PropTypes.node),
};

export default AuditOperationCell;
